import { Component } from '@angular/core';
import { Http } from '@angular/http';
import {ToasterService} from 'angular2-toastr';
import { Cam } from './cam';
import { CamService } from './cam.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [CamService, ToasterService]
})
//'../../node_modules/angular2-toaster/toaster.css'
export class AppComponent {
  title = 'Webcam Game';
  cams: Cam[];
  editingCam = null;
  difficulty = 0;
  actionbarVisible = false;

  constructor(private http: Http, private camService: CamService, private toasterService: ToasterService) {
    let that = this;
    camService.getCams().then(function(cams: Cam[]) {
      that.cams = cams;

      that.cams.map(function(cam: Cam) {
        camService.updateCam(cam);
      });
    });

    toasterService.success('Welcome', 'Welcome to the Game!', true, 10000);
  }

  foundCam(cam: Cam): void {
    cam.isFound = !cam.isFound;
  }

  editCam(cam: Cam): boolean {
    console.log('Editing', cam);
    this.editingCam = cam;

    // Don't show contextmenu
    return false;
  }

  stopEditingCam(cam: Cam): void {
    this.editingCam = null;

    this.updateCam(cam);
  }

  removeCam(camToRemove: Cam): void {
    this.cams = this.cams.filter(item => item !== camToRemove);
  }

  removeAllCams(): void {
    this.cams = [];
  }

  storeCams(): void {
    this.camService.storeCams(this.cams).then(function() {
      alert('Successfully stored cams');
    });
  }

  addCam(): void {
    let names: string[] = ['Jan', 'Piet', 'Truus', 'Kees', 'Henk', 'Mohammed', 'Abdulah', 'Anna'];
    let name: string = names[Math.floor(Math.random() * names.length)];

    let ip = '10.0.0.0';
    if (this.cams.length > 0) {
      ip = this.cams[0].ip;
    }
    let cam: Cam = new Cam(ip, name);

    this.cams.push(cam);
  }

  updateDifficulty(difficulty: number): void {
    this.difficulty = difficulty;

    for (let cam of this.cams) {
      cam.quality = 100 - this.difficulty;
      this.camService.updateCam(cam);
    }
  }

  updateCam(cam: Cam) {
    this.camService.updateCam(cam);
  }

  toggleActionbar() {
    this.actionbarVisible   = !this.actionbarVisible;
  }
}


// WEBPACK FOOTER //
// /home/rene/Documents/webcamgame/src/app/app.component.ts